"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes2 = require("@decisiv/prop-types");

var _Link = _interopRequireDefault(require("../../Link"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

var _constants = require("../constants");

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CustomLink = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "Link__CustomLink",
  componentId: "sc-1a88cpd-0"
})(["&&{border-radius:0;color:", ";height:", ";padding:0 ", ";outline:none;:hover{background-color:", ";}:focus{border-color:", ";box-shadow:inset 0 0 0 1px ", ";}:hover,:visited{svg path{color:", ";fill:", ";}}}"], (0, _toColorString.default)(_constants.BG_COLOR.fg), (0, _rem.default)(_constants.TOP_NAV_HEIGHT), (0, _rem.default)(_constants.ELEMENT_PADDING), (0, _toColorString.default)(_constants.BG_COLOR_HOVER), (0, _toColorString.default)(_constants.BG_COLOR_FOCUS), (0, _toColorString.default)(_constants.BG_COLOR_FOCUS), (0, _toColorString.default)(_constants.BG_COLOR.fg), (0, _toColorString.default)(_constants.BG_COLOR.fg));

function Link(props) {
  var ariaLabel = props['aria-label'],
      text = props.text;

  if (ariaLabel && !text) {
    return _react.default.createElement(_Tooltip.default, {
      target: _react.default.createElement(CustomLink, props),
      placement: "bottom"
    }, ariaLabel);
  }

  return _react.default.createElement(CustomLink, props);
}
/* eslint-disable react/require-default-props, react/default-props-match-prop-types */
// @ts-ignore


Link.propTypes = _objectSpread({}, _schema.default.propTypes, {
  'aria-label': (0, _propTypes2.requireIf)(_propTypes.default.string, function (_ref) {
    var text = _ref.text;
    return (0, _isEmpty.default)(text);
  }),
  icon: _propTypes.default.elementType,
  text: (0, _propTypes2.requireIf)(_propTypes.default.string, function (_ref2) {
    var icon = _ref2.icon;
    return (0, _isEmpty.default)(icon);
  })
});
Link.defaultProps = {
  icon: undefined,
  iconPosition: 'left',
  size: 'medium',
  variant: 'normal'
};
/* eslint-enable */

var _default = Link;
exports.default = _default;